import React from 'react';
import { UserSettingsBase } from './user-settings.base';

export const UserSettingsClosed = () => <UserSettingsBase />;
